import type { Guard } from './types'
import hasRole from '../../Utils/hasRole.ts'
import type { Role } from '../../Constants/Role.ts'

export function createHasRoleGuard(...roles: Role[]): Guard {
  return () => hasRole(roles)
}
